import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AlertType } from "@app/core/services/alert/alerts.service";

@Component({
  selector: 'app-alert-dialog',
  styles: [`
    .button-close {
      background-color: var(--grey-color) !important;
      height: 60px;
      font-size: 1rem;
      border-radius: 0 0 inherit inherit;
    }
  `],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="rounded-4">
      <div class="modal-body d-flex flex-column align-items-center text-center mx-2">
        <img [src]="iconSrc" height="70px" alt="Timer icon" class="my-3">  
        <p [innerHTML]="message"></p>
      </div>
      <button type="button"
        class="btn button-close w-100"
        (click)="modalRef.close('Close click')">
        {{ buttonText }}
      </button>
    </div>
  `
})
export class AlertDialogueComponent {
  title: string = "";
  message: string = "";
  alertType: AlertType = "success";
  buttonText: string = "Close";

  constructor(public modalRef: NgbActiveModal) {
  }

  get iconSrc(): string {
    switch (this.alertType) {
      case 'success':
        return 'assets/img/icons/Union.svg';
      case 'warning':
        return 'assets/img/icons/warning.svg';
      case 'error':
        return 'assets/img/icons/error.svg';
      case 'info':
        return 'assets/img/icons/Confirmation.svg';
      default:
        return 'assets/img/icons/Union.svg';
    }
  }
}
